import { gql } from '@apollo/client';

export const postDemandaIFE = gql`
mutation DemandaColectivaIFEModelRQ{
    DemandaColectivaIFEModelRQ(input: $input)  
        @rest(type: "DemandaColectivaIFEModelRS", path: "/api/gateway/formulariosComercios/solicitudife",  method: "post"){
                       
            resultado
            mensaje
        }
}
`